import { render, staticRenderFns } from "./AnnullaFatture.vue?vue&type=template&id=433947fe"
import script from "./AnnullaFatture.vue?vue&type=script&lang=js"
export * from "./AnnullaFatture.vue?vue&type=script&lang=js"
import style0 from "./AnnullaFatture.vue?vue&type=style&index=0&id=433947fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports